/**
 * Admin Data Table Component
 */
import React from 'react';
import { AdminAccount } from './adminManagement';
import editIcon from '../../../assests/icons/edit_icon.png';
import eraserIcon from '../../../assests/icons/eraser_icon.png';
import './adminDataTable.css';

export interface AdminDataTableProps {
  admins: AdminAccount[];
  onEditClick?: (admin: AdminAccount) => void;
  onDeleteClick?: (admin: AdminAccount) => void;
}

const AdminDataTable: React.FC<AdminDataTableProps> = ({
  admins,
  onEditClick,
  onDeleteClick,
}) => {
  const handleDelete = (admin: AdminAccount) => {
    if (!window.confirm(`「${admin.name}」を削除しますか？`)) return;
    onDeleteClick?.(admin);
  };

  return (
    <div className="admin-data-table">
      <div className="admin-data-table__container">
        <table className="admin-data-table__table">
          <thead>
            <tr>
              <th>番号</th>
              <th>氏名</th>
              <th>メールアドレス</th>
              <th>連絡先番号</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            {admins.length > 0 ? (
              admins.map((admin, index) => (
                <tr key={admin.id} className="admin-data-table__row">
                  <td>{index + 1}</td>
                  <td>{admin.name}</td>
                  <td>{admin.email}</td>
                  <td>{admin.contactNumber}</td>
                  <td>
                    <div className="admin-data-table__actions">
                      <button
                        type="button"
                        className="admin-data-table__action-btn admin-data-table__action-btn--edit"
                        onClick={() => onEditClick?.(admin)}
                        aria-label="編集"
                      >
                        <img src={editIcon} alt="" aria-hidden />
                      </button>
                      <button
                        type="button"
                        className="admin-data-table__action-btn admin-data-table__action-btn--delete"
                        onClick={() => handleDelete(admin)}
                        aria-label="削除"
                      >
                        <img src={eraserIcon} alt="" aria-hidden />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="admin-data-table__empty">
                  登録されている管理者はいません
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminDataTable;
